export default function CtaPlanos() {
    return (
        <>
            <section id="cta" class="cta">
                <div class="container">

                    <div class="row" data-aos="zoom-in">
                        <div class="col-lg-9 text-center text-lg-start">
                            <h3>MELHORE SEU PLANO DE INTERNET FIBRA ÓTICA</h3>
                            <p> Conheça agora os novos planos de internet Netsim Telecom. E fique por dentro dos beneficios que a Netsim tem para você. E mude agora para um plano melhor!  </p>
                        </div>
                        <div class="col-lg-3 cta-btn-container text-center">
                            <a class="cta-btn align-middle" href="https://netsimtelecom.com.br/cobertura">Ver agora</a>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}